import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
import MainLandPackage from '../entities/back-mainlandpackage'
import appconst from '@/lib/appconst';


interface MainLandPackageState extends ListState<MainLandPackage> {
    total: any;
    MainLandPackageInfo: MainLandPackage,
}

class MainLandPackageMutations extends ListMutations<MainLandPackage>{

}
class MainLandPackageInfo extends ListModule<MainLandPackageState, any, MainLandPackage>{
    state = {
        totalCount: 0,
        total: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<MainLandPackage>(),
        loading: false,
        MainLandPackage: MainLandPackage,


    }
    actions = {
        async getAll(context: ActionContext<MainLandPackageState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/BackMainLandPackage/GeMainLandPackageList', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<MainLandPackage>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async getMainLandPackageList(context: ActionContext<MainLandPackageState, any>, payload: any) {
            let reponse = await Ajax.get('/api/services/app/BackMainLandPackage/GetSelectShipmentList', { params: payload.data });
            let result = reponse.data.result as Array<MainLandPackageState>;
            return result;
        },
        async editMainLandPackage(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/BackMainLandPackage/EditMainLandPackage', payload.data);
        },
    };
}

const mainlandpackageinfo = new MainLandPackageInfo();
export default mainlandpackageinfo;